import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from "react-redux";
import store from "./redux/store";
import App from './App';


store.subscribe(() => {
  const { user, token } = store.getState().auth;

  localStorage.setItem('user', JSON.stringify(user));
  localStorage.setItem('token', token);
});

const container = document.getElementById('root');
const root = createRoot(container); // createRoot(container!) if you use TypeScript
root.render(
  <React.StrictMode>
    <Provider store={store}>
     <App />
    </Provider>
  </React.StrictMode>
);